enum LocalStorageKeysEnum {
    TOKEN = 'token',
    REFRESH_TOKEN = 'refreshToken',
}

export default LocalStorageKeysEnum;
